module.exports = __webpack_public_path__ + "img/twitter.b757f2bc.png";